import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { DrupalRESTService } from './drupal-rest.service';

export interface ExportDataset {
  key: string;
  label: string;
  icon: string;
  description: string;
  endpoint: string | null;
  filename: string | null;
  available: boolean;
}

@Injectable({ providedIn: 'root' })
export class DataExportService {

  constructor(
    private _drupalRESTService: DrupalRESTService,
    private _http: HttpClient,
  ) {}

  getManifest(): Observable<ExportDataset[]> {
    return this._drupalRESTService.httpGET('/api/v1/exports/manifest', []).pipe(
      map((res: any) => (res?.datasets ?? []) as ExportDataset[])
    );
  }

  downloadCSV(endpoint: string, filename: string, params: Array<{ parameter: string; value: string }> = []): Observable<any> {
    const paramArray = params.some(p => p.parameter === '_format')
      ? params
      : [...params, { parameter: '_format', value: 'csv' }];

    return this._drupalRESTService.downloadFile(endpoint, paramArray).pipe(
      tap((response: any) => this._saveBlob(response.body, response.type, `${filename}_${this._today()}.csv`))
    );
  }

  downloadBundle(keys: string[], studioId: number | null = null): Observable<any> {
    const body: { keys: string[]; studio_id?: number } = { keys };
    if (studioId !== null && studioId !== undefined) {
      body.studio_id = studioId;
    }
    return this._drupalRESTService._csrfToken().pipe(
      switchMap((token) =>
        this._http.post(`${environment.hostUrl}/api/v1/exports/bundle`, body, {
          headers: { 'X-CSRF-Token': token, 'Content-Type': 'application/json' },
          withCredentials: true,
          observe: 'response',
          responseType: 'blob',
        })
      ),
      tap((response) => {
        const blob = response.body!;
        this._saveBlob(blob, blob.type || 'application/zip', `studio-backup_${this._today()}.zip`);
      })
    );
  }

  private _saveBlob(body: BlobPart, type: string, filename: string): void {
    const blob = body instanceof Blob ? body : new Blob([body], { type });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  private _today(): string {
    return new Date().toISOString().slice(0, 10);
  }
}
